import { render } from "./Regist.vue?vue&type=template&id=3f7fc40d&scoped=true"
import script from "./Regist.vue?vue&type=script&lang=js"
export * from "./Regist.vue?vue&type=script&lang=js"

import "./Regist.vue?vue&type=style&index=0&id=3f7fc40d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7fc40d"]])

export default __exports__